var React = require('react');

function ReminderAgentVendor (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.048 5.296c.059 0 .115.016.157.046L9.872 7.97c.17.122.17.32 0 .442l-3.547 2.542a.282.282 0 0 1-.308 0 .139.139 0 0 1-.064-.108L5.92 9.37H1.146c-.173 0-.313-.152-.313-.34V7.674c0-.188.14-.34.313-.34h4.729l-.042-1.878c-.002-.086.094-.157.215-.159zM3.952 0c.12.001.217.072.215.159l-.043 1.878h4.73c.173 0 .313.152.313.34v1.358c0 .187-.14.34-.313.34L4.08 4.073 4.047 5.55c-.001.04-.024.08-.064.108a.282.282 0 0 1-.308 0L.128 3.116c-.17-.122-.17-.32 0-.442L3.795.046A.269.269 0 0 1 3.952 0z","fill":"currentColor","fillRule":"nonzero"}));
}

ReminderAgentVendor.defaultProps = {"width":"11","height":"12","viewBox":"0 0 11 12"};

module.exports = ReminderAgentVendor;

ReminderAgentVendor.default = ReminderAgentVendor;
